import { MatterDeleteValidation } from 'types/matters';
import { t } from 'utils/getTranslations';

// Priority order mirrors MatterBizService.validateMatterBeforeDeleting so the
// frontend warning matches the exception that would have been thrown if the
// backend validation ran first. Returns null when there are no blockers.
export const buildDeleteBlockerMessage = (validation: MatterDeleteValidation): string | null => {
    if (validation.hasTimecards) {
        const base = t('matters.alerts.delete-blocked-timecards');
        return validation.draftTimecardAuthors.length > 0
            ? base +
                  ' ' +
                  t('matters.alerts.delete-blocked-timecards-authors-suffix', {
                      authors: validation.draftTimecardAuthors.join(', '),
                  })
            : base;
    }
    if (validation.hasExpenses) {
        return t('matters.alerts.delete-blocked-expenses');
    }
    if (validation.hasInvoices) {
        return t('matters.alerts.delete-blocked-invoices');
    }
    if (validation.hasInvoiceTimecards) {
        return t('matters.alerts.delete-blocked-invoice-timecards');
    }
    if (validation.hasInvoiceExpenses) {
        return t('matters.alerts.delete-blocked-invoice-expenses');
    }
    if (validation.hasInvoiceRows) {
        return t('matters.alerts.delete-blocked-invoice-rows');
    }
    if (validation.hasClientAssets) {
        return t('matters.alerts.delete-blocked-client-assets');
    }
    return null;
};
